var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsnQty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#ECB80B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 16.2969L13.0625 14.1406L10.9062 11.9844",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7891 4.79688V7.67188C13.7891 8.05312 13.9405 8.41876 14.2101 8.68834C14.4797 8.95792 14.8453 9.10938 15.2266 9.10938H18.1016",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60156 11.2656V6.23437C6.60156 5.85313 6.75301 5.48749 7.0226 5.21791C7.29218 4.94833 7.65781 4.79688 8.03906 4.79688H14.5078L18.1016 8.39062V17.7344C18.1016 18.1156 17.9501 18.4813 17.6805 18.7508C17.4109 19.0204 17.0453 19.1719 16.6641 19.1719H8.03906C7.65781 19.1719 7.29218 19.0204 7.0226 18.7508C6.75301 18.4813 6.60156 18.1156 6.60156 17.7344V15.5781C6.60156 15.1969 6.75301 14.8312 7.0226 14.5617C7.29218 14.2921 7.65781 14.1406 8.03906 14.1406H13.0703",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsnQty);
export default __webpack_public_path__ + "static/media/asnQty.c920a95277083fd7553051a629e4ddb3.svg";
export { ForwardRef as ReactComponent };